'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _jsx = require('@babel/runtime/helpers/jsx');
var React = require('react');
var classNames = require('classnames');
var context = require('@andes/context');
var isWebviewIOSOs = require('@andes/common/build/utils/isWebviewIOS');
var button = require('@andes/button');
var Close24 = require('@andes/icons/Close24');
var writeToClipBoard = require('@andes/common/build/utils/writeToClipboard');
var badge = require('@andes/badge');
var common = require('@andes/common');
var Copy16 = require('@andes/icons/Copy16');
var snackbar = require('@andes/snackbar');
var typography = require('@andes/typography');
var FeedbackNegative40 = require('@andes/icons/FeedbackNegative40');
var thumbnail = require('@andes/thumbnail');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _jsx__default = /*#__PURE__*/_interopDefaultLegacy(_jsx);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var isWebviewIOSOs__default = /*#__PURE__*/_interopDefaultLegacy(isWebviewIOSOs);
var Close24__default = /*#__PURE__*/_interopDefaultLegacy(Close24);
var writeToClipBoard__default = /*#__PURE__*/_interopDefaultLegacy(writeToClipBoard);
var Copy16__default = /*#__PURE__*/_interopDefaultLegacy(Copy16);
var FeedbackNegative40__default = /*#__PURE__*/_interopDefaultLegacy(FeedbackNegative40);
const namespace = 'andes-technical-error';
var module$3 = "@andes/technical-error";
var locale$2 = "en-US";
var translations$2 = {
  "andes-technical-error\u0004Cerrar": [null, "Close"],
  "andes-technical-error\u0004Código": [null, "Code"],
  "andes-technical-error\u0004Código copiado": [null, "Code copied"],
  "andes-technical-error\u0004Copiar": [null, "Copy"],
  "andes-technical-error\u0004Si el problema persiste, puedes reportarlo en la sección de Ayuda con el siguiente código": [null, "If the problem persists, you can report it in the Help section with the following code"],
  "andes-technical-error\u0004Algo salió mal": [null, "Something went wrong"],
  "andes-technical-error\u0004Estamos trabajando para solucionarlo": [null, "We are working to fix it"],
  "andes-technical-error\u0004¡Parece que no hay internet!": [null, "Looks like there is no internet connection!"],
  "andes-technical-error\u0004Revisa tu conexión para seguir navegando": [null, "Please check your internet connection to continue browsing"]
};
var enTranslations = {
  module: module$3,
  locale: locale$2,
  translations: translations$2
};
var module$2 = "@andes/technical-error";
var locale$1 = "es-AR";
var translations$1 = {
  "andes-technical-error\u0004Cerrar": [null, "Cerrar"],
  "andes-technical-error\u0004Código": [null, "Código"],
  "andes-technical-error\u0004Código copiado": [null, "Código copiado"],
  "andes-technical-error\u0004Copiar": [null, "Copiar"],
  "andes-technical-error\u0004Si el problema persiste, puedes reportarlo en la sección de Ayuda con el siguiente código": [null, "Si el problema persiste, puedes reportarlo en la sección de Ayuda con el siguiente código"],
  "andes-technical-error\u0004Algo salió mal": [null, "Algo salió mal"],
  "andes-technical-error\u0004Estamos trabajando para solucionarlo": [null, "Estamos trabajando para solucionarlo"],
  "andes-technical-error\u0004¡Parece que no hay internet!": [null, "¡Parece que no hay internet!"],
  "andes-technical-error\u0004Revisa tu conexión para seguir navegando": [null, "Revisa tu conexión para seguir navegando"]
};
var esTranslations = {
  module: module$2,
  locale: locale$1,
  translations: translations$1
};
var module$1 = "@andes/technical-error";
var locale = "pt-BR";
var translations = {
  "andes-technical-error\u0004Cerrar": [null, "Fechar"],
  "andes-technical-error\u0004Código": [null, "Código"],
  "andes-technical-error\u0004Código copiado": [null, "Código copiado"],
  "andes-technical-error\u0004Copiar": [null, "Copiar"],
  "andes-technical-error\u0004Si el problema persiste, puedes reportarlo en la sección de Ayuda con el siguiente código": [null, "Se o problema persistir, você pode reportá-lo na seção Ajuda, usando o código a seguir"],
  "andes-technical-error\u0004Algo salió mal": [null, "Ocorreu um erro"],
  "andes-technical-error\u0004Estamos trabajando para solucionarlo": [null, "Estamos trabalhando para resolvê-lo"],
  "andes-technical-error\u0004¡Parece que no hay internet!": [null, "Sem conexão com a internet!"],
  "andes-technical-error\u0004Revisa tu conexión para seguir navegando": [null, "Verifique sua conexão para continuar navegando"]
};
var ptTranslations = {
  module: module$1,
  locale: locale,
  translations: translations
};
const CloseButton = _ref => {
  let {
    color,
    onClose
  } = _ref;
  const i18n = context.getPatchedI18n(context.AndesContext, enTranslations, esTranslations, ptTranslations);
  return /*#__PURE__*/_jsx__default["default"]("button", {
    className: "".concat(namespace, "__close-button"),
    "aria-label": i18n.pgettext(namespace, 'Cerrar'),
    onClick: onClose,
    type: "button"
  }, void 0, /*#__PURE__*/_jsx__default["default"](Close24__default["default"], {
    color: color,
    "aria-hidden": true
  }));
};
CloseButton.displayName = 'CloseButton';
var CloseButton$1 = CloseButton;
var _Copy, _Pill;
const ErrorCodeButton = /*#__PURE__*/function () {
  const ErrorCodeButton = _ref => {
    let {
      className,
      errorCode,
      variant = 'screen',
      errorCodeDescription
    } = _ref;
    const {
      device
    } = React.useContext(context.AndesContext);
    const isMobile = device === null || device === void 0 ? void 0 : device.mobile;
    const isScreen = variant === 'screen';
    const i18n = context.getPatchedI18n(context.AndesContext, enTranslations, esTranslations, ptTranslations);
    const [copyProcess, setCopyProcess] = React.useState(false);
    const copyTimeout = React.useRef();
    React.useEffect(() => () => {
      clearTimeout(copyTimeout.current);
    }, []);
    const errorCodeButtonClassNames = classNames__default["default"]("".concat(namespace, "__code-button"), className, {
      ["".concat(namespace, "__code-button--snackbar")]: !isScreen,
      ["".concat(namespace, "__code-button--copied")]: !isScreen && copyProcess
    });
    const copyCode = async () => {
      if (copyProcess) return;
      await writeToClipBoard__default["default"](errorCode).catch(error => {
        throw error;
      });
      setCopyProcess(true);
      copyTimeout.current = setTimeout(() => {
        setCopyProcess(false);
      }, 3000);
    };
    const CopyButton = () => /*#__PURE__*/_jsx__default["default"]("button", {
      className: errorCodeButtonClassNames,
      onClick: copyCode,
      "aria-live": isMobile ? 'assertive' : undefined,
      type: "button"
    }, void 0, (!copyProcess || isScreen) && /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/_jsx__default["default"](typography.Text, {
      color: isScreen ? 'secondary' : 'inverted',
      size: "xs"
    }, void 0, "".concat(i18n.pgettext(namespace, 'Código'), ":\xA0")), /*#__PURE__*/_jsx__default["default"](typography.Text, {
      color: isScreen ? 'link' : 'inverted',
      size: "xs",
      className: "".concat(namespace, "__error-code")
    }, void 0, "".concat(errorCode, "\xA0")), /*#__PURE__*/_jsx__default["default"]("span", {
      className: "".concat(namespace, "__copy-icon-container")
    }, void 0, _Copy || (_Copy = /*#__PURE__*/_jsx__default["default"](Copy16__default["default"], {
      "aria-hidden": true
    }))), /*#__PURE__*/_jsx__default["default"](common.VisuallyHidden, {}, void 0, i18n.pgettext(namespace, 'Copiar'))), copyProcess && !isScreen && /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/_jsx__default["default"](typography.Text, {
      color: isScreen ? 'secondary' : 'primary',
      size: "xs"
    }, void 0, "".concat(i18n.pgettext(namespace, 'Código copiado'), "\xA0")), _Pill || (_Pill = /*#__PURE__*/_jsx__default["default"](badge.Pill, {
      contentType: "icon",
      color: "green",
      size: "small"
    }))));
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/_jsx__default["default"](typography.Text, {
      className: "".concat(namespace, "__code-text"),
      color: isScreen ? 'secondary' : 'inverted',
      size: "xs",
      component: "p"
    }, void 0, errorCodeDescription || "".concat(i18n.pgettext(namespace, 'Si el problema persiste, puedes reportarlo en la sección de Ayuda con el siguiente código'), ":")), /*#__PURE__*/_jsx__default["default"](CopyButton, {}), isScreen && /*#__PURE__*/_jsx__default["default"](snackbar.Snackbar, {
      show: copyProcess,
      message: i18n.pgettext(namespace, 'Código copiado'),
      color: "green",
      delay: 3000
    }));
  };
  ErrorCodeButton.displayName = 'ErrorCodeButton';
  return ErrorCodeButton;
}();
var ErrorCodeButton$1 = ErrorCodeButton;
const ErrorScreen = _ref => {
  var _FeedbackNegative;
  let {
    action,
    asset: Illustration,
    className,
    closable = false,
    description,
    errorCode,
    onClose,
    title,
    errorCodeDescription
  } = _ref;
  const andesGray550 = 'rgba(0, 0, 0, 0.55)';
  const {
    device
  } = React.useContext(context.AndesContext);
  const isMobile = device === null || device === void 0 ? void 0 : device.mobile;
  const isWebviewIOS = isWebviewIOSOs__default["default"](device);
  const containerClassNames = classNames__default["default"](className, "".concat(namespace, "__container"), {
    ["".concat(namespace, "__container--webview-ios")]: isWebviewIOS
  });
  const assetContainerClassNames = classNames__default["default"]("".concat(namespace, "__asset-container"), {
    ["".concat(namespace, "__asset-container--illustration")]: Illustration
  });
  const NoneAssetIcon = () => /*#__PURE__*/_jsx__default["default"](thumbnail.Thumbnail, {
    className: "".concat(namespace, "__none-asset-icon"),
    size: "64"
  }, void 0, _FeedbackNegative || (_FeedbackNegative = /*#__PURE__*/_jsx__default["default"](FeedbackNegative40__default["default"], {
    color: andesGray550,
    "aria-hidden": true
  })));
  return /*#__PURE__*/_jsx__default["default"]("div", {
    className: containerClassNames
  }, void 0, isMobile && closable && /*#__PURE__*/_jsx__default["default"](CloseButton$1, {
    color: andesGray550,
    onClose: onClose
  }), /*#__PURE__*/_jsx__default["default"]("div", {
    className: assetContainerClassNames
  }, void 0, Illustration || /*#__PURE__*/_jsx__default["default"](NoneAssetIcon, {})), /*#__PURE__*/_jsx__default["default"](typography.Title, {
    className: "".concat(namespace, "__title"),
    component: "h2"
  }, void 0, title), description && /*#__PURE__*/_jsx__default["default"](typography.Text, {
    className: "".concat(namespace, "__description")
  }, void 0, description), errorCode && /*#__PURE__*/_jsx__default["default"](ErrorCodeButton$1, {
    errorCode: errorCode,
    errorCodeDescription: errorCodeDescription
  }), action && /*#__PURE__*/_jsx__default["default"](button.Button, {
    className: "".concat(namespace, "__action-button"),
    hierarchy: "transparent",
    onClick: action.onClick,
    href: action.href,
    target: action.target,
    rel: action.rel
  }, void 0, action.text));
};
ErrorScreen.displayName = 'ErrorScreen';
var ErrorScreen$1 = ErrorScreen;
const SnackbarWithErrorCode = _ref => {
  let {
    action,
    actionLink,
    className,
    errorCode,
    message,
    errorCodeDescription,
    show = false,
    delay,
    onClose,
    onOpen
  } = _ref;
  const snackbarClassNames = classNames__default["default"](className, namespace, "".concat(namespace, "--snackbar"));
  return /*#__PURE__*/_jsx__default["default"](snackbar.Snackbar, {
    actionLink: actionLink,
    className: snackbarClassNames,
    message: message,
    action: action,
    show: show,
    color: "red",
    delay: delay,
    onClose: onClose,
    onOpen: onOpen
  }, void 0, /*#__PURE__*/_jsx__default["default"](ErrorCodeButton$1, {
    errorCode: errorCode,
    errorCodeDescription: errorCodeDescription,
    variant: "snackbar"
  }));
};
SnackbarWithErrorCode.displayName = 'SnackbarWithErrorCode';
var SnackbarWithErrorCode$1 = SnackbarWithErrorCode;
exports.ErrorScreen = ErrorScreen$1;
exports.SnackbarWithErrorCode = SnackbarWithErrorCode$1;
